var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: {
        title:
          _vm.id === null ? "Cadastrar Profissional" : "Editar Profissional",
      },
    },
    [
      _vm.id && _vm.checklist.length
        ? _c(
            "div",
            { staticClass: "mb-4" },
            [
              _c(
                "b-alert",
                {
                  attrs: {
                    variant: _vm.checklistCompleto ? "success" : "warning",
                    show: "",
                  },
                },
                [
                  _c("div", { staticClass: "alert-body" }, [
                    _c("p", { staticClass: "font-semibold mb-2" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.checklistCompleto
                              ? "Cadastro completo — pronto para enviar para análise."
                              : "Falta completar para enviar para análise:"
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "ul",
                      { staticClass: "mb-0 pl-4" },
                      _vm._l(_vm.checklist, function (item) {
                        return _c(
                          "li",
                          { key: item.key },
                          [
                            _c("feather-icon", {
                              staticClass: "mr-1 align-middle",
                              class: item.ok ? "text-success" : "text-warning",
                              attrs: {
                                icon: item.ok
                                  ? "CheckCircleIcon"
                                  : "CircleIcon",
                                size: "14",
                              },
                            }),
                            _c(
                              "span",
                              {
                                class: [
                                  item.ok ? "text-muted" : "",
                                  item.ok ? "" : "font-semibold",
                                ],
                              },
                              [_vm._v(_vm._s(item.label))]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isTabDisabled
        ? _c(
            "b-alert",
            { staticClass: "mb-4", attrs: { variant: "secondary", show: "" } },
            [
              _c("div", { staticClass: "alert-body" }, [
                _vm._v(
                  " Salve os dados básicos abaixo para liberar as demais abas (endereço, telefone, dados bancários, modalidades e as outras) — elas dependem do cadastro já existir. "
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c(
        "vs-tabs",
        {
          attrs: { color: _vm.colorx },
          model: {
            value: _vm.tabIndex,
            callback: function ($$v) {
              _vm.tabIndex = $$v
            },
            expression: "tabIndex",
          },
        },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Dados Básicos" } },
            [
              _c("ProfessionalForm", {
                ref: "professionalForm",
                attrs: {
                  services: _vm.services,
                  legalEntityId: _vm.id,
                  professional: _vm.professional,
                },
                on: { "update-data": _vm.handleUpdateData },
              }),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Endereço", disabled: _vm.isTabDisabled } },
            [
              _vm.professional.people_id
                ? _c("Address", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.professional.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: {
                label: "Região de atuação",
                disabled: _vm.isTabDisabled,
              },
            },
            [
              _vm.professional.id
                ? _c("ServiceArea", {
                    attrs: {
                      services: _vm.services,
                      legalEntityId: _vm.professional.id,
                      professional: _vm.professional,
                    },
                    on: { "save-radius": _vm.saveRadius },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Telefone", disabled: _vm.isTabDisabled } },
            [
              _vm.professional.people_id
                ? _c("Phone", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.professional.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Email", disabled: _vm.isTabDisabled } },
            [
              _vm.professional.people_id
                ? _c("Email", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.professional.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: { label: "Dados Bancários", disabled: _vm.isTabDisabled },
            },
            [
              _vm.professional.people_id
                ? _c("Bank", {
                    attrs: {
                      services: _vm.services,
                      serviceDelegate: _vm.services.legalEntityService,
                      entityId: _vm.id,
                      people_id: _vm.professional.people_id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            { attrs: { label: "Modalidades", disabled: _vm.isTabDisabled } },
            [
              _vm.professional.people_id
                ? _c("Modality", {
                    attrs: {
                      services: _vm.services,
                      serviceDelegate: _vm.services.legalEntityService,
                      people_id: _vm.professional.people_id,
                      entityId: _vm.id,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: {
                label: "Entidade de classe",
                disabled: _vm.isTabDisabled,
              },
            },
            [
              _vm.professional.people_id && _vm.teacherId
                ? _c("ClassEntity", {
                    attrs: {
                      services: _vm.services,
                      people_id: _vm.professional.people_id,
                      teacherId: _vm.teacherId,
                    },
                  })
                : _vm.professional.people_id
                ? _c("b-alert", { attrs: { variant: "warning", show: "" } }, [
                    _c("div", { staticClass: "alert-body" }, [
                      _vm._v(
                        " Este cadastro ainda não tem registro de professor associado, então não é possível informar o conselho de classe. "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _c(
            "vs-tab",
            {
              attrs: { label: "Repasse (Stripe)", disabled: _vm.isTabDisabled },
            },
            [
              _vm.professional.id
                ? _c("StripeConnect", {
                    attrs: { legalEntityId: _vm.professional.id },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.canSeeBillingPlan
            ? _c(
                "vs-tab",
                {
                  attrs: {
                    label: "Plano de Cobrança",
                    disabled: _vm.isTabDisabled,
                  },
                },
                [
                  _vm.professional.id
                    ? _c("BillingPlan", {
                        attrs: { legalEntityId: _vm.professional.id },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "vs-tab",
            { attrs: { label: "Imagens", disabled: _vm.isTabDisabled } },
            [
              _vm.professional.people_id
                ? _c("Images", {
                    attrs: {
                      serviceDelegate: _vm.services.legalEntityService,
                      people_id: _vm.professional.people_id,
                      entityId: _vm.professional.id,
                      imagesList: _vm.professional.images,
                      target: "legal_entities",
                      hint: "Tamanho recomendado: mínimo 1200×900px — fotos adicionais exibidas na galeria do perfil e ampliadas ao clicar.",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }